var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-carousel"},_vm._l((_vm.items),function(n){return _c('div',{key:n,staticClass:"skeleton skeleton-square"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }